// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"274":"c3c5e922","387":"c46f4a95","853":"04c94ece","915":"fd4b810f"}[chunkId] + ".css";
};